//
import request from "@/api/api";

export function getResRegionTree(query) {
  return request({
    url: "/resource/resregion/common/tree",
    method: "get",
    params: query,
  });
}
